import React from 'react';
import { makeStyles, Tooltip } from '@material-ui/core';
const useStylesTooltip = makeStyles((theme) => ({
    arrow: {
        color: theme.palette.common.black,
    },
    tooltip: {
        backgroundColor: theme.palette.common.black,
        fontSize: '15px'
    },
}));

export const CustomTooltip = (props) => {
    const classes = useStylesTooltip();
    return <Tooltip arrow classes={classes} {...props} />;
}
